<template>
	<div class="alert_bg">
		<div
			:class="{
				alert_body: true,
				alert_body_vip: $store.state.user.vip_left > 0,
			}"
		>
			<div class="close_btn" @click="onCancelClick"></div>
			<div class="warn_icon"></div>
			<div class="warn_title">设备绑定数已达上限</div>
			<div class="warn_tips" v-if="$store.state.user.vip_left <= 0">
				您当前可绑定{{
					$store.state.limit.bind.normal
				}}台设备，<br /><font @click="onPayClick">开通小宝会员</font
				>可绑定{{ $store.state.limit.bind.vip }}台设备
			</div>
			<div class="warn_tips" v-else>
				<div>如需绑定更多设备请使用微信扫一扫添加客服</div>
				<div class="failed_qrcode"></div>
			</div>
			<div class="btns" v-if="$store.state.user.vip_left <= 0">
				<div class="cancel_btn" @click="onCancelClick">取消</div>
				<div class="pay_btn" @click="onPayClick">开通会员</div>
			</div>
			<div class="btns vip_btns" v-else>
				<div class="cancel_btn" @click="onCancelClick">取消</div>
				<div class="qun_btn" @click="onCancelClick">确定</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions } from "vuex";
export default {
	methods: {
		...mapActions(["sendUserlog"]),
		onCancelClick: function () {
			let _that = this;
			_that.sendUserlog([
				"bind_limit_cancel_click",
				_that.$store.state.user.vip_left > 0 ? 1 : 0,
			]);
			_that.$emit("onCancelClick");
		},
		onPayClick: function () {
			let _that = this;
			_that.sendUserlog([
				"bind_limit_pay_click",
				_that.$store.state.user.vip_left > 0 ? 1 : 0,
			]);
			_that.$emit("onPayClick");
		},
	},
	mounted: function () {
		let _that = this;
		// alert("mounted");
		_that.sendUserlog([
			"bind_limit",
			_that.$store.state.user.vip_left > 0 ? 1 : 0,
		]);
	},
};
</script>

<style lang="less" scoped>
.alert_bg {
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	background-color: rgba(82, 82, 82, 0.36);
	z-index: 9;

	.alert_body.alert_body_vip {
		height: 400px;
		margin-top: -200px;
	}

	.alert_body {
		width: 300px;
		height: 306px;
		left: 50%;
		top: 50%;
		margin-left: -150px;
		margin-top: -153px;
		background-color: #ffffff;
		background-image: linear-gradient(to bottom, #fff5ec, #fcfcfc);
		position: absolute;
		border-radius: 5px;

		.close_btn {
			width: 20px;
			height: 20px;
			position: absolute;
			right: 10px;
			top: 10px;
			background-image: url(../../assets/common/close4.svg);
			background-size: 100% 100%;
			cursor: pointer;
			z-index: 2;
		}
		.close_btn:hover {
			opacity: 0.8;
			cursor: pointer;
		}

		.warn_icon {
			margin: 0 auto;
			margin-top: 40px;
			height: 58px;
			width: 58px;
			background-size: 100% 100%;
			background-image: url("../../assets/common/warn_icon.svg");
		}
		.warn_title {
			margin-top: 30px;
			font-weight: bolder;
			color: #1a1a1a;
			font-size: 17px;
			text-align: center;
		}
		.warn_tips {
			color: #999999;
			font-size: 12px;
			width: 250px;
			margin: 0 auto;
			margin-top: 10px;
			line-height: 20px;
			text-align: center;
			font {
				color: #daae84;
			}
			font:hover {
				cursor: pointer;
				opacity: 0.8;
			}
		}

		.btns {
			text-align: center;
			margin-top: 40px;
		}

		.pay_btn {
			display: inline-block;
			vertical-align: top;
			width: 88px;
			height: 36px;
			line-height: 36px;
			color: #5f4509;
			background-color: #e9c29b;
			background-image: linear-gradient(
				140deg,
				#f2d7b3 4%,
				#e9c29b 57%,
				#d9ad84 100%
			);
			box-shadow: 0px 3px 10px 1px rgba(131, 106, 46, 0.1);
			border-radius: 58px 58px 58px 58px;
			opacity: 1;
			text-align: center;
			margin: 0 auto;
			font-size: 14px;
		}
		.pay_btn:hover {
			opacity: 0.9;
			cursor: pointer;
		}

		.failed_qrcode {
			width: 126px;
			height: 126px;
			margin: 0 auto;
			margin-top: 10px;
			background-color: #cccccc;
			background-image: url(../../assets/common/kf_qrcode.jpg);
			background-repeat: no-repeat;
			background-size: 100% 100%;
			border: 5px solid #eaeaea;
		}

		.qun_btn {
			display: inline-block;
			vertical-align: top;
			width: 88px;
			height: 36px;
			line-height: 36px;
			color: #ffffff;
			background-color: rgba(31, 93, 227, 1);
			box-shadow: 0px 3px 10px 1px rgba(131, 106, 46, 0.1);
			border-radius: 58px 58px 58px 58px;
			opacity: 1;
			text-align: center;
			margin: 0 auto;
			font-size: 14px;
		}
		.qun_btn:hover {
			opacity: 0.9;
			cursor: pointer;
		}

		.cancel_btn {
			display: inline-block;
			vertical-align: top;
			margin: 0 auto;
			border-radius: 20px;
			width: 88px;
			height: 36px;
			line-height: 36px;
			margin-right: 15px;
			font-size: 14px;
			background-color: rgba(230, 230, 230, 1);
			color: rgba(153, 153, 153, 1);
			text-align: center;
			text-decoration: none;
		}
		.cancel_btn:hover {
			opacity: 0.8;
			cursor: pointer;
		}

		.btns.vip_btns {
			margin-top: 20px;
			.cancel_btn {
				margin-left: 0px;
			}
		}
	}
}
</style>